import React from 'react';
import PropTypes from 'prop-types';
import HavrProvider from './HavrProvider.react';
import SampleProvider from './SampleProvider.react';
import NavigationContext from './Context';

class MUXNavigationProvider extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <SampleProvider>
                <NavigationContext.Consumer>
                    {(sampleNavigation) => (
                        <HavrProvider tourId={this.props.tourId}>
                            <NavigationContext.Consumer>
                                {(havrNavigation) => (
                                    <NavigationContext.Provider
                                        value={sampleNavigation || havrNavigation}
                                    >
                                        {this.props.children}
                                    </NavigationContext.Provider>
                                )}
                            </NavigationContext.Consumer>
                        </HavrProvider>
                    )}
                </NavigationContext.Consumer>
            </SampleProvider>
        );
    }
}

MUXNavigationProvider.propTypes = {
    tourId: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default MUXNavigationProvider;
